<template>
  <t-row class="permissions-table-row">
    <t-column size="" v-tooltip="action.defaultLabelTitle" class="permissions-table-row-header row-header-selector">
      <span class="header-text">{{ action.defaultLabelTitle }}</span>
    </t-column>
    <t-column v-for="permittee in permissionsTablePermittees" :key="`${action.client_id}_${permittee.client_id}`" size="">
      <row>
        <input
            :id="`enable_action_permission_${action.client_id}_${permittee.client_id}`"
            type="checkbox"
            @input="createDestroyPermission(permittee, action, ObjectModelPermissionCapabilityType.Enable)"
            :checked="!!permissionFor(permittee, action, ObjectModelPermissionCapabilityType.Enable)"
            :disabled="disabled(permittee)"
        >
        <label :for="`enable_action_permission_${action.client_id}_${permittee.client_id}`">
          Enable
          <help-tooltip>{{ tooltip(permittee) }}</help-tooltip>
        </label>
      </row>
    </t-column>
    <t-column :class="`empty_cell`" v-for="index in remainingColumns" :key="`empty_cell_${index}`" size=""><row>&nbsp;</row></t-column>
  </t-row>
</template>

<script lang="ts">
import Vue from 'vue';
import selectedMixin from "../mixins/selectedMixin";
import ObjectModelPermissionMixin from '../mixins/object-model-permission-mixin';
import permissionTablePermitteesMixin from '../mixins/permission-table-permittees-mixin';
import ObjectModelAction from "~/models/objectModelActions/objectModelAction";
import {ObjectModelPermissionType} from "~/enums/objectModelPermissionType";
import {StringHelper} from "~/helpers/stringHelper";
import remainingColumnMixin from "../mixins/remaining-column-mixin";
import {ObjectModelPermissionDefinition} from '~/models/objectModels/objectModelPermissionDefinition'
import {PermitteeType} from '~/enums/permitteeType'
import {IPermittee} from '~/interfaces/permitteeInterfaces'
import {ObjectModelDefaultActionType} from '~/enums/objectModelDefaultActionType'

export default Vue.extend({
  mixins: [
    selectedMixin,
    ObjectModelPermissionMixin,
    permissionTablePermitteesMixin,
    remainingColumnMixin
  ],
  props: {
    action: {
      type: Object as () => ObjectModelAction,
      required: true,
    }
  },
  computed: {
    permissionType(): ObjectModelPermissionType {
      return ObjectModelPermissionType.Action;
    },
    actionTitleTooLong(): boolean {
      return this.action.defaultLabelTitle?.length > 20;
    },
    actionTitleShort(): string {
      return StringHelper.limitString(this.action.defaultLabelTitle, 20);
    },
  },
  methods: {
    disabled(permittee: IPermittee): boolean {
      return !ObjectModelPermissionDefinition.canCreate({permittee, permittable: this.action})
    },
    tooltip(permittee: IPermittee): string {
      switch (permittee.reference_type) {
        case PermitteeType.objectOwner:
          switch (this.action.default_action_type) {
            case ObjectModelDefaultActionType.Create:
              return 'Disabled because record holder is not available until after creation'
            case ObjectModelDefaultActionType.Edit:
              return 'Disabled because record holder is not allowed to edit their own record directly'
          }
      }
      return ''
    },
  },
});
</script>